import Widget from "components/Layout/Widget";
import RecordLabel from "components/RecordLabel";
import { DashboardWidgetConfig, FeRecordType } from "config/config";
import "./PercentageList.scss";

interface PercentagePerLocationProps {
    data: {
        link: string | null;
        name: string;
        image: string | null;
        percentage: number;
        type: FeRecordType;
    };
}

const PercentagePerLocation = ({ data }: PercentagePerLocationProps) => {
    const { link, name, image, percentage, type } = data;
    return (
        <div>
            <div className="percentage-list">
                <div className="percentage-list__item" key={`${name}${percentage}`}>
                    <RecordLabel link={link} name={name} image={image} iconByType={type} />
                    <div className="flex items-center">
                        <div className="percentage-list__bar flex-1">
                            <div style={{ width: `${percentage}%` }} />
                        </div>
                        <span className="text-bold text-sm">{percentage}%</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const PercentageList = ({
    config,
    stats,
}: {
    config: DashboardWidgetConfig;
    stats: any;
}) => {
    const data = config?.dto?.({ stats });

    if (data?.length === 0) return <Widget.Empty />;

    return data.map((dataPerLocation) => (
        <PercentagePerLocation data={dataPerLocation} key={dataPerLocation.name} />
    ));
};
